import React, { useEffect, FC } from 'react';
import { IRootState } from '@store/root/rootState';
import { useDispatch, useSelector } from 'react-redux';
import PageLoader from 'Components/loader/pageLoader';
import { GeneralError } from 'Components/helpers';
import Analytics from '@analytics/index';
import SocketProxy from '@analytics/socket/socketProxy';

interface Props {
  children: any;
}

const YouVisitAnalytics: FC<any> = ({ children }: Props) => {
  const dispatch = useDispatch();
  const tourModel = useSelector((state: IRootState) => state.tour);
  const analyticsModel = useSelector((state: IRootState) => state.analytics);

  useEffect(() => {
    if (tourModel.isStandalone) {
      Analytics.YouVisitAnalytics.init(
        tourModel.instId,
        tourModel.locId,
        tourModel.tourid,
        tourModel.platform,
        dispatch
      );
    } else {
      Analytics.EventAnalytics.init({
        socket: new SocketProxy(),
      });
    }
  }, [tourModel, dispatch]);

  // Are we still parsing data to set redux?
  if (!analyticsModel.isReady) return <PageLoader />;
  if (!tourModel.instId)
    return <GeneralError message="Failed to initialize form configuration." />;
  return children;
};

export default YouVisitAnalytics;
try {
    // @ts-ignore
    YouVisitAnalytics.displayName = "YouVisitAnalytics";
    // @ts-ignore
    YouVisitAnalytics.__docgenInfo = { "description": "", "displayName": "YouVisitAnalytics", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/hoc/YouVisitAnalytics/YouVisitAnalytics.tsx#YouVisitAnalytics"] = { docgenInfo: YouVisitAnalytics.__docgenInfo, name: "YouVisitAnalytics", path: "src/hoc/YouVisitAnalytics/YouVisitAnalytics.tsx#YouVisitAnalytics" };
}
catch (__react_docgen_typescript_loader_error) { }